export const APP_TITLE = 'SeasonOne Admin';
export const SEPARATOR = ' - ';
export const ATS = 'ATS';
export const PREBOOK = 'PREBOOK';
export const IDLE_SECONDS = 86400;
export const TIMEOUT_PERIOD_SECONDS = 5;
export const PAGE_SIZE = 12;
export const PROD_PAGE_SIZE = 18;
export const SFL_ID = 5;
export const ISO_FORMAT = 'YYYY-MM-DDT00:00:00';
export const DEFAULT_LANG = 'en-US';
export const APP_TYPE = 'admin';
export const ALPHA_NUMERIC_PATTERN = /^[a-zA-Z0-9 '`._-]*$/;
export const ALPHA_NUMERIC_STRICT_PATTERN = /^[a-zA-Z0-9._-]*$/;
export const URL_PATTERN =
  '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
export const DIGIT_ONLY_PATTERN = /^[0-9]*$/;
export const LOGIN_ID_PATTERN =
  /^(([A-Za-z0-9+._-]*)|([A-Za-z0-9+_.-]+@[A-Za-z0-9+_.-]+))$/;
export const ALPHA_NUMERIC_PD_PATTERN = /^[a-zA-Z0-9$&#@!*^._-]*$/;
export const PWD_PATTERN =
  /^(?=.*\d)(?=.*[!@#$^&*])(?=.*[a-z])(?=.*[A-Z]).{7,20}$/;
export const FILE_PATH_PATTERN = /^(?=.*?)((?![\\|<>\\*\"]).)*$/;

export const maxStepperNumber = 7;

export enum experienceType {
  shopping = 'SHOPPING',
  package = 'PACKAGE',
}

export const BREADCRUMB_TITLE = {
  HOME: 'Home',
  WEB_SERVICE: {
    MANAGE_WEB_SERVICE: 'Manage Web Service',
    NEW_WEB_SERVICE: 'New Web Service',
    UPDATE_WEB_SERVICE: 'Update Web Service',
    WEB_SERVICE_TEST: 'Web Service Test',
    WEB_SERVICE_DETAIL: 'Web Service Details',
  },
  NEWS: {
    MANAGE_NEWS: 'Manage News',
    NEW_NEWS: 'New News',
    UPDATE_NEWS: 'Update News',
    NEWS_DETAIL: 'News Detail',
  },
  MESSAGE: {
    MANAGE_MESSAGE: 'Manage Message',
    NEW_MESSAGE: 'New Message',
    UPDATE_MESSAGE: 'Update Message',
    MESSAGE_DETAIL: 'Message Detail',
  },
  COLLECTION: {
    COLLECTIONS: 'Collections',
    NEW_COLLECTION: 'New collection',
  },
  STATIC_CONTENT: {
    MANAGE_STATIC_CONTENT: 'Manage Web Service',
    NEW_STATIC_CONTENT: 'New Web Service',
    UPDATE_STATIC_CONTENT: 'Update Web Service',
    STATIC_CONTENT_DETAIL: 'Web Service Details',
  },
  GROUPS: {
    MANAGE_GROUPS: 'Manage Groups',
    NEW_GROUPS: 'New Group',
    UPDATE_GROUPS: 'Update Group',
    GROUPS_DETAIL: 'Group Detail',
  },
  MENU: {
    MANAGE_MENU: 'Manage Menus',
    NEW_MANAGE_MENU: 'New Menu',
    UPDATE_MANAGE_MENU: 'Update Menu',
    MANAGE_MENU_DETAIL: 'Menu Details',
  },

  PROPOSAL: {
    PROPOSALS: 'proposals',
  },
};

export const ProposalSteps = {
  CreateEvent: 1,
  EventExperience: 2,
  OtherEvent: 3,
  PeopleNotify: 4,
  InstructionalText: 5,
  ConsolidateOrders: 6,
  Products: 7,
};

export const wizards = {
  events: 'EVENT',
  promotions: 'PROMOS',
  virtualProShop: 'VPS',
};

export const stepperHeaders = [
  { title: 'Event Details', label: 'Event type, Name' },
  {
    title: 'Event/Member Pricing',
    label: 'Member price, margin, create budget',
  },
  {
    title: 'Additional Event Details',
    label: 'Supporting text will come here',
  },
  { title: 'Event Notification', label: 'Supporting text will come here' },
  { title: 'Microsite Details', label: 'Add additional prices and details' },
  {
    title: 'Member Info & Approval',
    label: 'Notify more people during event',
  },
  { title: 'Add/Select Products', label: 'Add instruction & detail text' },
];

export const MEMBER_SITE_BASE_LOCAL = `http://localhost:4300`;
export const EMAIL_REGEX_PATTERN =
  /^[a-zA-Z0-9](\.?[a-zA-Z0-9_-]){0,}@[a-zA-Z0-9-]+\.([a-zA-Z]{1,}\.)?([a-zA-Z]{2,}\.)?[a-zA-Z]{2,}$/;